import React from 'react';

import { cancelPurchase } from 'api';
import { transformErrorResponse } from 'helpers/errors';
import FormError from '../FormError';
import ReactModal from 'react-modal';

export default class CancelPurchaseInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSent: false,
      error: undefined,
      showModal: false,
    };
  }

  async cancelInvoice(id) {
    try {
      const { status } = await cancelPurchase(id);
      await this.props.findPurchase(id);
      if (status === 200) {
        this.setState({
          isSent: true,
          error: undefined,
          showModal: false,
        });
      }
    } catch ({ response }) {
      const error = transformErrorResponse(response.data);
      this.setState({
        error,
        isSent: false,
        showModal: false,
      });
    }
  }

  toggleModal(state) {
    this.setState({ showModal: state });
  }

  render() {
    const { purchaseId, className } = this.props;
    const { isSent, error } = this.state;

    return purchaseId ? (
      <React.Fragment>
        <button
          onClick={() => this.toggleModal(true)}
          className={`btn btn-lg btn-danger ${className}`}
          disabled={isSent}
        >
          Cancel Purchase
        </button>
        {isSent ? <div>Invoice has been cancelled.</div> : null}
        {error ? <FormError error={error} /> : null}

        <ReactModal
          appElement={document.getElementById('root')}
          isOpen={this.state.showModal}
          contentLabel="Confirm Cancel Purchase Modal"
          portalClassName="AdjustmentCreditPortal"
          overlayClassName="AdjustmentCreditModal__Overlay"
          className="AdjustmentCreditModal__Content"
        >
          <div className="modal-header">
            <span className="close">&times;</span>
            <h2>Confirm Cancel Purchase</h2>
          </div>
          <div className="modal-body">
            <p>Are you sure you want to cancel this purchase?</p>
          </div>
          <div className="modal-footer">
            <button
              className={'btn btn-primary'}
              onClick={() => this.cancelInvoice(purchaseId)}
            >
              Confirm
            </button>
            <button
              className={'btn'}
              onClick={() => {
                this.toggleModal(false);
              }}
            >
              Cancel
            </button>
          </div>
        </ReactModal>
      </React.Fragment>
    ) : null;
  }
}
